import styled from 'styled-components'

export const Wrapper = styled.div`
  .ant-progress-inner,
  .ant-progress-bg {
    height: 12px !important;
  }
`

export const Title = styled.div`
  font-size: 12px;
  color: #000000;
  float: left;
`

export const OverallProgress = styled.div`
  float: right;
  font-size: 12px;
  color: #000000;
  span {
    font-weight: 700;
  }
`
